<div
  class="flex flex-column justify-content-between h-full"
  [ngStyle]="{ 'min-width': tabs.length > 0 ? '40px' : 'unset' }">
  <!-- for main tab -->
  <div class="sidebar">
    <ng-container *ngFor="let tab of tabs">
      <div
        *ngIf="!tab?.isSub"
        class="sidebar-item flex flex-grow gap-3"
        (click)="onTab(tab.path)"
        [ngClass]="{ active: tab.isActive }">
        <div><svg-icon [key]="tab.svg" [size]="tab.sizeIcon"></svg-icon></div>
        <div
          class="sidebar-title"
          [ngClass]="expandMenu$ ? '' : 'hide-sidebar'">
          {{ tab.title }}
        </div>
      </div>
    </ng-container>
  </div>

  <!-- for sub tab -->
  <div class="sidebar mt-auto justify-content-end">
    <ng-container *ngFor="let tab of tabs">
      <div
        *ngIf="tab?.isSub"
        class="sidebar-item flex flex-grow gap-3"
        (click)="onTab(tab.path)"
        [ngClass]="{ active: tab.isActive }">
        <div
          *ngIf="
            numberUnreadSupportCases > 0 && tab.title == 'Live Support';
            else notBadge
          "
          pBadge
          severity="danger"
          [value]="
            numberUnreadSupportCases > 99
              ? '+99'
              : numberUnreadSupportCases.toString()
          ">
          <svg-icon [key]="tab.svg" [size]="tab.sizeIcon"></svg-icon>
        </div>
        <ng-template #notBadge>
          <div><svg-icon [key]="tab.svg" [size]="tab.sizeIcon"></svg-icon></div>
        </ng-template>

        <div
          class="sidebar-title"
          [ngClass]="expandMenu$ ? '' : 'hide-sidebar sub-hide-sidebar'">
          {{ tab.title }}
        </div>
      </div>
    </ng-container>
  </div>
</div>
